import React from 'react';
import {
	PeopleSearchBoxList,
	CascadeResultsTableComp,
	CascadeResultsHeaderTableComp
} from './rolluptable.component';
import { ErrorTextComp,TextareaFieldComp } from '../../../inputs/fields.component'
import GoalServices from '../../../../services/goal.services';
import PermissionComp from './permission.component';
import * as MetricFunc from '../../../../utils/metric';
import { TypeFaceText } from '../../../inputs/buttons.component';
import SearchBoxComp from '../../../inputs/searchbox.component';
import HelpTextComp from '../../../helper/helptext.component';
import { CheckBoxComp } from '../../../inputs/fields.component';
import { reactLoader, removeReactLoader, autoResizeTextArea } from '../../../../utils/common';
import { isNumberWithComma, uniqueArrayObject } from "../../../../utils/function";
import TeamServices from "../../../../services/team.services";
import DeleteCommonModal from '../../../../components/deleteCommonModal.component';
import KrAlignDependance from '../../../../components/okr/wizard/key_results/krAlignDependence';
import AddKrTag from "../../../../krTags/components/addkrTag.component"
import { Textfield, Checkbox, Dropdown } from '@workboard/wobo-ui';
import styled from 'styled-components';
import {getTargetValue} from '../../../common/getTargetValue.component'
import Customokr from "../../../custom_fields/customobj/Customokr";
import KrRelationshipWrapper from './krRelationshipWrapper';
import KrMilestonesSection from './KrMilestonesSection';
import { krdetailConstants } from '../../../../constants/krdetails.constants';
import { AddFinancialTargetsButton } from '../AddFinancialTargetsButton';
import { isKrDurationChangedFromSaved } from '../../../../utils/krQuarterDuration';

const StyledCheckbox = styled(Checkbox)`
  .MuiButtonBase-root {
    width: 24px;
    height: 24px;
    margin-left: -5px;
		padding: 0;
  }
  input{
    display: inline-block !important;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;

const StyledDropdown = styled(Dropdown)`
	min-width: 113px !important;
	max-width: fit-content;
	height: 39px !important
	> svg {
		margin-right: 10px !important;
	}
	.MuiSelect-root {
		background-color: #f2f2f2 !important;
		border: 1px solid rgba(0,0,0,0.06);
		height: 38px;
	}
	.MuiSelect-select.Mui-disabled {
		.MuiListItemText-root{
			color: rgba(0, 0, 0, 0.87) !important;
		}
	}
	.MuiSelect-icon.Mui-disabled{
		display: none;
	}
	#unit-measure-dropdown{
		min-width: 177px;
	}
	#cal-overall-dropdown{
		min-width: 226px;
	}
	#select-day-dropdown{
		min-width: 120px;
	}
	#select-interval-dropdown{
		min-width: 113px;
	}
	#result-value-dropdown{
		min-width: 220px;
	}
`;

class CascadeKRComp extends React.Component {

	constructor(props) {
		super(props);
		const { t } = props;
		this.message = `${t('I am cascading you this key result from my objective so that you can track it.')} ${t('You can either pick it up and make updates yourself, delegate someone else to make updates, recascade the key result to others, or link to an existing key result.')}`;
		let metricObj = {
			interval: 2, weekly_update_day: 5, target: '', stretch: '',
			lower_limit: '', upper_limit: '', counting: 1,
			progress_consider: false, initial_data: 0, metric: 1,
			metricCascdeUserList: [],
			progress_type: 1,
			measure_metric_data: this.props.item.measure_metric_data ? this.props.item.measure_metric_data  : 5,
			message: this.message
		};
		let isStretchEnabled = this.props.addOkrData.isStretchEnabled ?? this.props.goalDetails.isStretchEnabled ?? false
		let committedKRFlag = isStretchEnabled && this.props.item && parseInt(this.props.item.committed_target) ? parseInt(this.props.item.committed_target) : 0;
		if (Object.keys(this.props.item).length) {
			let { source, type } = this.props.item;
			metricObj = Object.assign({}, metricObj, this.props.item);
			metricObj.progress_consider = (metricObj.progress_consider === '0') ? true : false;
			metricObj.progress_type = (metricObj.progress_type == 1 || metricObj.progress_type == 2) ? 2 : metricObj.progress_type;
			metricObj.measure_metric_data = metricObj.measure_metric_data;
			metricObj.metric = metricObj.metric == "0" ? 1 : metricObj.metric;
			if (type == 1) {
				metricObj.message = this.message;
				metricObj.progress_type = 2;
			}
			metricObj.counting = metricObj.counting  ? metricObj.counting : 1;
			metricObj.initial_data = metricObj.initial_data == "" ? 0 : metricObj.initial_data;
			metricObj.stretch = (isStretchEnabled && this.props.item.stretch_target !== null) ? this.props.item.stretch_target :
								(isStretchEnabled && this.props.item.target && !committedKRFlag) ? this.props.item.target : '';
			metricObj.target  = (!isStretchEnabled && this.props.item.target) ||
							    (isStretchEnabled && committedKRFlag && this.props.item.stretch_target == null) ||
							    (isStretchEnabled && this.props.item.stretch_target !== null) ? this.props.item.target : '';
		}
		const isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled ?? false;
		//console.log('metricObj', metricObj);
		this.state = {
			metricObj,
			errors: {},
			hide: false,
			teamPermissionSelected:
				this.props.item && this.props.item.permission_teams
				? this.props.item.permission_teams
				: this.props.goalDetails.type == 1 &&
							this.props.goalDetails.default_permission_teams &&
							Object.keys(this.props.goalDetails.default_permission_teams).length > 0
							? this.props.goalDetails.default_permission_teams : [],
			bizPermissionSelected:  this.props.item && this.props.item.permission_biz ? this. props.item.permission_biz : [],
			permissionstate:
				this.props.item && this.props.item.permission
				? this.props.item.permission.split(",").map(Number)
				: this.props.goalDetails.type == 1 ? (this.props.goalDetails.default_permission &&
					Object.keys(this.props.goalDetails.default_permission).length > 0 ? this.props.goalDetails.default_permission.split(",").map(Number) : [8])  : [10],
			checkedValues: [],
			permissionHelpPopUp: false,
			confirmPopup: false,
			krAlingSelected: this.props.item &&
               this.props.item.kr_aligns !== undefined &&
               this.props.item.kr_aligns.length > 0
                ? this.props.item.kr_aligns
                : [],
      		krDependenciesSelected: this.props.item &&
                  this.props.item.kr_dependent !== undefined &&
                  this.props.item.kr_dependent.length > 0
                    ? this.props.item.kr_dependent
                    : [],
			tags:[],
			nplTags:this.props.nplTags ? this.props.nplTags : [],
			selectednlplTags:this.props.selectednlplTags ? this.props.selectednlplTags : [],
			selectednlplTagsName:this.props.selectednlplTagsName ? this.props.selectednlplTagsName : [],
			tagsList:this.props.tagsList ? this.props.tagsList:[],
			customFiledRequired:false,
			isCustomSave:[],
			isRequirdCustomOkr:[],
			customInputData:[],
			isAnuualQChange:false,
			isStretchEnabled: isStretchEnabled,
			coOwners: isKrCoOwnerEnabled ? (this.props.item.coOwners && this.props.item.coOwners.length > 0 ? this.props.item.coOwners : (this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [])) : [],
			milestones: this.props.item?.milestones ?? [],
		};


		this.changeTargetDropdownValue = this.changeTargetDropdownValue.bind(this);
		this.changeMetricTypeOptions = this.changeMetricTypeOptions.bind(this);
		this.changeInputValue = this.changeInputValue.bind(this);
		this.saveCascadeResults = this.saveCascadeResults.bind(this);
		this.renderPeopleSearchResults = this.renderPeopleSearchResults.bind(this);
		this.removeItem = this.removeItem.bind(this);
		this.clickPeople = this.clickPeople.bind(this);
		this.changeInterval = this.changeInterval.bind(this);
		this.changeWeekDayUpdate = this.changeWeekDayUpdate.bind(this);
		this.changeProgressType = this.changeProgressType.bind(this);
		this.changeExcludeObjective = this.changeExcludeObjective.bind(this);
		this.changeMessageText = this.changeMessageText.bind(this);
		this.changeTextBox = this.changeTextBox.bind(this);
		this.renderError = this.renderError.bind(this);
		this.sendUserNotification = this.sendUserNotification.bind(this);

		this.permissionData = this.permissionData.bind(this);
		this.teamPermissionData = this.teamPermissionData.bind(this);
		this.filterPeopleList = this.filterPeopleList.bind(this);

		this.checkPeopleValue = this.checkPeopleValue.bind(this);
		this.GoalServices = new GoalServices();
		this.krMilestonesSectionRef = React.createRef();

		this.initialMetricTypeOptions = MetricFunc.getMetricTypeOptions().map(m => ({ ...m, name: t('Count as') + ' ' + m.name.toLowerCase() }));

		this.sendRequest = false;
		this.teamUserCollections = {};
		this.TeamServices = new TeamServices();

		this.exitDeleteModal = this.exitDeleteModal.bind(this);
		this.saveItems = this.saveItems.bind(this);
		this.saveAlignArr = this.saveAlignArr.bind(this);
		this.getMilestonesPayload = this.getMilestonesPayload.bind(this);
		this.handleMilestonesChange = this.handleMilestonesChange.bind(this);
    	this.saveDependentArr = this.saveDependentArr.bind(this);
		this.updateTags = this.updateTags.bind(this);
		this.isRequiredCustomOkrFiled = this.isRequiredCustomOkrFiled.bind(this);
		this.isSaveCustom =this.isSaveCustom.bind(this)
		this.renderError = this.renderError.bind(this);

		this.saveItemsCompleted = this.saveItemsCompleted.bind(this);
	}

	sendUserNotification(item) {
		this.GoalServices.sendCascdePingNotification({
			metricId: item.pkr_id,
			reqUserID: item.req_uid
		}).then((response) => {
			if (response.data) {
				if ($('.infoPopup').length) {
					$('.infoPopup').css("z-index", 5000001);
				}
				infoPopup.call(item.firstname +' '+ t('will get a notification and an email asking for an update'));
			}
		});
	}


	permissionData(perData) {
		this.setState({
			permissionstate: perData
		});
	}

	teamPermissionData(teamPerData) {
		this.setState({
			teamPermissionSelected: teamPerData
		});
	}

	bizPermissionData = (bizPerData) => {
    this.setState({
      bizPermissionSelected: bizPerData
    });
  }
    componentDidMount() {
    	this.props.setSavedAnnualDuration(this.props.item.isQuarter,this.props.item.quarter_name,this.props.item.id)
  	}
	renderError(field) {
		return <ErrorTextComp errors={this.state.errors} field={field} />;
	}

	getErrorClass(field) {
		return (typeof this.state.errors[field] !== 'undefined') ? ' errorBorder  ' : '';
	}

	changeTextBox(e, item) {
		var v = e.target.value.trim();
		let metricObj = this.state.metricObj;
		let metricCascdeUserList = metricObj.metricCascdeUserList.map(u => {
			if (u.req_uid == item.req_uid) {
				u.target = ((v && isNumberWithComma(v)) || v == '') ? v : u.target;
			}
			return u;
		})
		this.setState({ metricObj: { ...metricObj, metricCascdeUserList } });
	}

	changeMessageText(e) {
		autoResizeTextArea(document.getElementById('message'));
		this.setState({ metricObj: { ...this.state.metricObj, message: e.target.value } });
	}

	changeTargetDropdownValue(e, item) {
		let errors = this.state.errors;
		if (typeof errors['initial_data'] !== 'undefined') {
			delete errors['initial_data'];
		}
		if (typeof errors['target'] !== 'undefined') {
			delete errors['target'];
		}
		if (typeof errors['lower_limit'] !== 'undefined') {
			delete errors['lower_limit'];
		}
		if (typeof errors['upper_limit'] !== 'undefined') {
			delete errors['upper_limit'];
		}
		if (typeof errors['stretch'] !== 'undefined') {
			delete errors['stretch'];
		}
		this.setState({ metricObj: { ...this.state.metricObj, counting: item, errors } });
	}

	changeInputValue(e) {
		var v = e.target.value.trim();
		let metricObj = this.state.metricObj;
		let errors = this.state.errors;
		let eventName = e.target.name;
		if (typeof metricObj[eventName] !== 'undefined') {
			if (typeof errors[eventName] !== 'undefined') {
				delete errors[eventName];
			}
			let val = ((v && isNumberWithComma(v)) || v == '') ? v : metricObj[eventName];
			let updateData = { [eventName]: val };
			this.setState({ metricObj: { ...metricObj, ...updateData }, errors });
		}
	}

	changeMetricTypeOptions(e, item) {
		if (item) {
			if(this.state.metricObj.id) {
				this.setState({ metricObj: { ...this.state.metricObj, metric: item} });
			} else {
				this.setState({ metricObj: { ...this.state.metricObj, metric: item, measure_metric_data: item == 3 ?  6 : 5} });
			}
		}
	}



	getMilestonesPayload() {
		// Ensure milestones is an array before attempting to use array methods
		if (!Array.isArray(this.state.milestones)) {
			return '';
		}
		// milestones need to be an object with keys as index and values as milestone object (for api request)
		const milestonesList = this.state.milestones
		  .filter((milestone) => milestone.date && (milestone.target == 0 || milestone.target))
		  .reduce((acc, milestone, index) => ({
				...acc,
				[index]: {
					id: milestone.id && typeof milestone.id === 'number' ? milestone.id : null,
					date: milestone.date,
					label: milestone.label,
					target: milestone.target,
				}
		  }), {});

		// if there are no milestones, return an empty string (for api request)
		return Object.keys(milestonesList).length > 0 ? milestonesList : '';
	}

	handleMilestonesChange(milestones) {
		this.setState({ milestones });
	}

	saveCascadeResults(isError = false) {
		console.log('saveCascadeResults');
		let errors = {};
		this.isSaveCustom(this.state.customInputData)
		this.setState({isCustomSave:[]})

		const { t } = this.props;
		// Check for milestones validation errors
		if (this.krMilestonesSectionRef.current && !this.krMilestonesSectionRef.current.validateMilestones()) {
			toastr.error(t('Milestone dates and values must be within start and target range'));
			return false;
		}

		let { metricObj } = this.state;
		let { counting, target, lower_limit, upper_limit, metricCascdeUserList, stretch } = metricObj;
		let metricName = $("#metric-name-text").val();
		if (
			typeof metricName === "undefined" ||
			metricName == null ||
			metricName == ""
		) {
			errors["metricName"] = true;
			document.getElementById('metric-name-text').setAttribute('aria-invalid', 'true')
			setTimeout(() =>{
				document.getElementById('metric-name-text').focus()
			})
		}
		if( this.state.isRequirdCustomOkr && this.state.isRequirdCustomOkr.length>0 ){
			errors["customokr"] = t('Please enter required field');
			this.setState({isCustomSave:this.state.isRequirdCustomOkr})

		  }
		if (counting == 4) {
			if (lower_limit == '') {
				errors['lower_limit'] = t('Enter value');
			}
			else if (lower_limit && !isNumberWithComma(lower_limit)) {
				errors['lower_limit'] = t('Enter numeric value');
			}
			if (upper_limit == '') {
				errors['upper_limit'] = t('Enter value');
			}
			else if (upper_limit && !isNumberWithComma(upper_limit)) {
				errors['upper_limit'] = t('Enter numeric value');
			}
			if (
				isNumberWithComma(lower_limit) &&
				isNumberWithComma(upper_limit) &&
				parseFloat(upper_limit) < parseFloat(lower_limit)
			) {
				errors["lower_limit"] =
					t("Lower limit value should be less than Upper limit value");
			}

		}
		else {
			if (this.state.isStretchEnabled) {
				if (target == '' && stretch == '') {
					errors['target'] = t('Enter value');
					errors['stretch'] = t('Enter value');
				}
			} else {
				if (target == '') {
					errors['target'] = t('Enter value');
				}
			}
			if (target && !isNumberWithComma(target)) {
				errors['target'] = t('Enter numeric value');
			}
			if (stretch && !isNumberWithComma(stretch)) {
				errors['target'] = t('Enter numeric value');
			}
			if ((target !== "" && isNumberWithComma(target)) && (stretch !== "" && isNumberWithComma(stretch))) {
				if ((counting == 1 || counting == 9) && parseFloat(stretch) < parseFloat(target)) {
				  	errors["stretch"] = t('Stretch target should be greater than committed');
				}
				if ((counting == 2 || counting == 8) && parseFloat(stretch) > parseFloat(target)) {
					errors["stretch"] = t('Stretch target should be less than committed');
				}
			}
		}

		if (!metricCascdeUserList.length) {
			errors['select_people'] = t('Search and select a person(s)');
		}

		if (Object.keys(errors).length) {
			this.setState({ errors }, () => {
				if(errors.metricName){
					$('.krRightPaneContent').parent().animate({ scrollTop: 0 });
				} else {
					let isErrorFocus = false;
					for(let i in errors){
						let ele = document.getElementById(i);
						if(ele){
							isErrorFocus = true;
							console.log('ele.clientHeight', ele.clientHeight);
							$('.krRightPaneContent').parent().animate({ scrollTop: ele.clientHeight });
							break;
						}
					}
					if(!isErrorFocus){
						$('.krRightPaneContent').parent().animate({ scrollTop: $(".krRightPaneContent")[0].scrollHeight - 150 });
					}
				}
			});
		}

		else {
			if (this.props.krType != this.props.lastType && this.props.addEditFlag) {
				this.setState({
					confirmPopup: true
				})
			}
			else if (isKrDurationChangedFromSaved(this.props.item, this.props.kr_duration, this.props.goalDetails)) {
				this.setState({
				  confirmPopup: true,
				  isAnuualQChange:true,
				})
			  }
			else {
				this.saveItems();
			}
		}


	}

	exitDeleteModal() {
		//console.log('exitmodel');
		this.setState({confirmPopup: false });
	}

	saveItemsCompleted(callback = null, data = {}) {
		window.dispatchEvent(new CustomEvent('krDataRefresh'));
		if (callback && typeof callback === 'function') {
			callback(data);
		} else {
			this.props.closeKrRightPane(true);
		}
	}
	saveItems(callback = null) {
		let params = {};
		let { metricObj } = this.state;
		let isError = false;
		let kr_duration =this.props.kr_duration;
		let isQuarter= this.props.isQuarter;

		let { counting, initial_data, target, lower_limit, upper_limit,
			metricCascdeUserList, stretch } = metricObj;
		//console.log('save metricObj', metricObj);
		let { actions, item, goalDetails } = this.props;
		let goalId = goalDetails.id;
		let permission = goalDetails.permission || "";
		if (typeof goalId !== 'undefined') {
			let krId;
			let _this = this;
			if (typeof item !== "undefined" && typeof item["id"] !== "undefined") {
				params.id = item["id"];
				krId = params.id;
			}
			let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
			let tagids=this.state.tags.length ? this.state.tags : ['']
			let finalTagsIds = [...nlpIds,...tagids]
			params.krTagIds = finalTagsIds;
			params.name = this.props.krText;
			params.kr_duration=kr_duration;
			params.isQuarter=isQuarter;
			params.isPeriodChange=this.state.isAnuualQChange
			params.description = this.props.krNote;
			params.interval = metricObj.interval;
			params.weekly_update_day = metricObj.weekly_update_day;
			params.progress_type = metricObj.measure_metric_data == 2 ? 3 : ( metricObj.measure_metric_data == 1 ? 2 : 1 ) ;
			params.counting = counting;
			params.metric = metricObj.metric;
			params.source = 9;
			params.real_owner = this.props.realOwner.id;
			let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
			params.coOwners = coOwners.length > 0 ? Array.prototype.map
			 .call(coOwners, s => s.id)
			 .toString() : '';
			params.type = 2;
			params.initial_data = initial_data;
			params.lower_limit = lower_limit;
			params.upper_limit = upper_limit;
			params.target = target;
			params.metricCascade = [];
			params.metricCascadeWithTarget = {};
			params.message = metricObj.message ? metricObj.message : this.message;
			params.progress_consider = metricObj.progress_consider ? 0 : 1;
			params.customField = JSON.stringify(this.props.customFieldsData);
			metricCascdeUserList.map(u => {
				params.metricCascade.push(u.req_uid);
				params.metricCascadeWithTarget[u.req_uid] = u.target;
			});
			params.stretchTarget = stretch;
			if (counting != 4) {
				params.upper_limit = '';
				params.lower_limit = '';
			}
			else {
				params.target = '';
				params.stretchTarget = '';
			}
			if (goalDetails && goalDetails.all_metrics == 1) {
				params.permission_teams = goalDetails.permission_teams;
				params.permission_biz = goalDetails.permission_biz;
				params.permission = permission;
			} else {
				params.permission_teams = this.state.teamPermissionSelected.map(
					val => val.id
				);
				params.permission_biz = this.state.bizPermissionSelected.map(val => val.id);
				params.permission = this.state.permissionstate.join(",");
			}
			params.measure_metric_data = metricObj.measure_metric_data;

			let krAlignSel = this.state.krAlingSelected;
			let dependentKrsSel = this.state.krDependenciesSelected;
			let krAligns = [];
			let dependentKrs = [];

			if (Object.keys(krAlignSel).length > 0) {
				krAlignSel.map(item => {
					krAligns.push(item.id);
				});
			}

			if (Object.keys(dependentKrsSel).length > 0) {
				dependentKrsSel.map(item => {
					dependentKrs.push(item.id);
				});
			}
			params.krAligns = krAligns;
			params.dependentKr = dependentKrs;
			// Include milestones data if available
			params.milestones = this.getMilestonesPayload();
			// console.log('going to save', params);
			if (!isError) {
				reactLoader(true);
				this.GoalServices.addEditKr({ goalId: goalId, metric: params }).then(
					response => {
						removeReactLoader();
						if (response.data) {
							this.setState({
								confirmPopup: false,
								isAnuualQChange:false,
							  });
							if (!this.props.onlyMetEdit) {
								let result = response.data.data;
								let krWeightage = null;
								if (result.krWeightage) {
									krWeightage = result.krWeightage;
									delete result['krWeightage'];
								}
								result = {
									clusterItems: this.props.clusterData,
									clusterCount: this.props.clusterData.length,
									...result
								};
								if (krId) {
									actions.editNewKr(krId, result);
								} else {
									actions.addNewKr(result);
								}
								if (krWeightage) {
									_this.props.MetricChangeWeight(krWeightage);
								}
							}
							this.saveItemsCompleted(callback, response.data.data);
							// _this.props.closeKrRightPane(true);
							// this.GoalServices.triggerGoalMetricDetails({goalId});
						}
					}
				);
			}
		}
	}
	isSaveCustom(isVal){
		let arr=[];
		let j=0;
		let keyArrCategory=[]
		let valArray = []
		isVal && Object.keys(isVal).forEach((v)=>{
		  j++;
		  isVal[v]["customFields"]&&
		  Object.keys(isVal[v]["customFields"]).forEach(objv=>{
			keyArrCategory.push(objv)
			if(isVal[v]["customFields"][objv]['is_required']=='1'
			&&( isVal[v]["customFields"][objv]["text"]  ==undefined || isVal[v]["customFields"][objv]["text"]  ==[])
			){
				 arr.push(objv,v)
				}
			if(isVal[v]["customFields"][objv]["text"]){
			  valArray.push(isVal[v]["customFields"][objv]["text"])
			}else{
			  valArray.push('')
				}
		  })
		  if(j==Object.keys(isVal).length){
			this.setState({isRequirdCustomOkr:[...arr]})
		  }
		  let finalDataArray=[]
		  for(let i=0;i<valArray.length;i++){
			if(Array.isArray(valArray[i])){
			  valArray[i].forEach(val => {
				finalDataArray.push({id:keyArrCategory[i],val:val.name,object_type:'6'})
			  })
			}
			else{
			  finalDataArray.push({id:keyArrCategory[i],val:valArray[i],object_type:'6'})
			}

		  }
		  const tempData=finalDataArray
		})

	  }

		isRequiredCustomOkrFiled(isVal,id){
		  let cust_id=this.state.isCustomSave.find((u) => u == id);
		  let ar=this.state.isCustomSave ? this.state.isCustomSave:'';
		  let fr= ar.filter(
			  (u) => u != cust_id
			)
		  this.setState({isCustomSave:fr})
		  this.isSaveCustom(isVal)
		  this.setState({customInputData:isVal})
		}
	renderPeopleSearchResults(values, searchboxInst) {
		if (values.length) {
			let offsetValue = document.querySelector('.offsettingInput');
			offsetValue = (offsetValue !== undefined && offsetValue !== null ? offsetValue.offsetHeight : 0)
			$('.krRightPaneContent').parent().animate({ scrollTop: 650 + offsetValue });
			let attr = {};
			attr.checkedValues = this.state.checkedValues;
			attr.checkBoxProps = {
				onChange: this.checkPeopleValue
			};
			return values.map(v => (
				<PeopleSearchBoxList
					key={v.type + "_" + v.userId + "_" + v.teamId}
					row={v}
					inst={searchboxInst}
					attr={attr}
				/>
			));
		} else {
			return null;
		}
	}

	constructTeamMemberUsers(users = []) {
		//console.log(users,"users");
		return users.map(u => ({
			firstname: u.name,
			lastname: u.lastName,
			fullName: `${u.name} ${u.lastName}`,
			req_uid: u.id,
			target: '',
			isNew: true,
			teamId: u.team_id
		}));
	}
	renderError(field) {
		return (
		  <ErrorTextComp key={field} errors={this.state.errors} field={field} />
		);
	  }
	checkPeopleValue(e, item, searchBoxInst) {
		if (item) {
			let _this = this;
			let { metricObj, checkedValues, errors } = this.state;
			let chk = e.target.checked;
			let itemId =
				item.type + "_" + (item.type == "2" ? item.teamId : item.userId);
			if (chk) {
				checkedValues = [...checkedValues, itemId];
				if (item.type == "2") {
					if (typeof this.teamUserCollections[item.teamId] == "undefined") {
						this.TeamServices.getTeamUserDetails({
							teamId: item.teamId,
							allUser: 1
						}).then(response => {
							if (response.data) {
								_this.teamUserCollections[item.teamId] = _this.constructTeamMemberUsers(response.data.inviteeList || []);
								if (typeof this.teamUserCollections[item.teamId] != "undefined") {
									let uniqueUsers = uniqueArrayObject([
										...metricObj.metricCascdeUserList,
										..._this.teamUserCollections[item.teamId]
									], 'req_uid');
									metricObj.metricCascdeUserList = uniqueUsers;
									_this.setState({ metricObj, checkedValues });
								}
							}
						});
					} else {
						if (typeof this.teamUserCollections[item.teamId] != "undefined") {
							let uniqueUsers = uniqueArrayObject([
								...metricObj.metricCascdeUserList,
								..._this.teamUserCollections[item.teamId]
							], 'req_uid');
							metricObj.metricCascdeUserList = uniqueUsers;
							_this.setState({ metricObj, checkedValues });
						}
					}
				} else {
					//console.log('item', item);
					let findUser = metricObj.metricCascdeUserList.find(
						u => u.req_uid == item.userId
					);
					if (!findUser) {
						let fullName = typeof item.fullName !== 'undefined' ? item.fullName : `${item.firstName} ${item.lastName}`;
						metricObj.metricCascdeUserList = [
							...metricObj.metricCascdeUserList,
							{
								firstname: item.firstName,
								lastname: item.lastName,
								fullName: fullName,
								req_uid: item.userId,
								target: '',
								isNew: true
							}
						];
					}
				}
			} else {
				if (item.type == "1") {
					metricObj.metricCascdeUserList = metricObj.metricCascdeUserList.filter(
						u => !(u.req_uid == item.userId && typeof u.isNew != 'undefined' && u.isNew == true)
					);
				} else if (item.type == "2") {
					if (typeof this.teamUserCollections[item.teamId] != "undefined") {
						metricObj.metricCascdeUserList = metricObj.metricCascdeUserList.filter(
							u => typeof u.teamId == "undefined" || u.teamId != u.teamId
						);
					}
				}
				checkedValues = checkedValues.filter(v => v != itemId);
			}
			if (typeof errors['select_people'] !== 'undefined') {
				delete errors['select_people'];
			}
			this.setState({ metricObj, checkedValues, errors });
		}
	}

	clickPeople(e, item, searchboxInst) {
		if (item) {
			$(e.target).trigger("mouseleave");
			//document.getElementById(e.target).onmouseleave();
			let errors = this.state.errors;
			let { metricCascdeUserList } = this.state.metricObj;
			let findUser = metricCascdeUserList.find(u => u.req_uid == item.userId);
			if (!findUser) {
				let firstname = item.firstName;
				let lastname = item.lastName;
				let fullName = item.fullName ? item.fullName : firstname + ' ' + lastname;
				let newUser = { firstname, lastname, fullName, req_uid: item.userId, target: '', isNew: true };
				metricCascdeUserList = [...metricCascdeUserList, newUser];
			}
			let updateData = { metricObj: { ...this.state.metricObj, metricCascdeUserList } };
			if (typeof errors['select_people'] !== 'undefined') {
				delete errors['select_people'];
				updateData.errors = errors;
			}
			this.setState({ ...this.state, ...updateData }, () => {
				if (searchboxInst) {
					searchboxInst.closeBox();
				}
			});
		}
	}

	removeItem(e, item) {
		if (item) {
			let metricObj = this.state.metricObj;
			let metricCascdeUserList = metricObj.metricCascdeUserList.filter(u => u.req_uid != item.req_uid);
			//console.log('metricCascdeUserList', metricCascdeUserList);
			let checkedValues = this.state.checkedValues.filter(
				u => u != `1_${item.req_uid}`
			);
			if(metricCascdeUserList.length == 0){
				checkedValues = [];
			}
			this.setState({ metricObj: { ...metricObj, metricCascdeUserList }, checkedValues });
		}
	}

	changeInterval(e, item) {
		if (item) {
			this.setState({ metricObj: Object.assign({}, this.state.metricObj, { interval: item }) });
		}
	}

	changeWeekDayUpdate(e, item) {
		if (item) {
			this.setState({ metricObj: Object.assign({}, this.state.metricObj, { weekly_update_day: item }) });
		}
	}

	changeProgressType(e, item) {
		this.setState({ metricObj: Object.assign({}, this.state.metricObj, { measure_metric_data: item }) });
	}

	changeExcludeObjective(e) {
		var chk = e.target.checked;
		this.setState({ metricObj: Object.assign({}, this.state.metricObj, { progress_consider: chk }) });
	}

	filterPeopleList(values = []) {
		if (Array.isArray(values) && values.length) {
			values = values.filter(u => u.type == 1);
		}
		return values;
	}
	saveAlignArr(alignData){
		this.setState({
		  krAlingSelected: alignData
		})
	}
	saveDependentArr(dependentData){
		this.setState({
		  krDependenciesSelected: dependentData
		})
	}
	saveTag = (childData) =>{
		this.setState({tags:childData})
	}
	updateTags(Newtags){
		this.setState({
		  selectednlplTagsName: Newtags
		})
	}
	render() {
		const { t, addOkrData = {} } = this.props;
		let { metricObj, errors = {} } = this.state;
		let isError = Object.keys(errors).length ? true : false;
		let isNew = (typeof metricObj['id'] !== 'undefined') ? false : true;
		const isOldDis = (!isNew && typeof metricObj['type'] !== 'undefined'
			&& metricObj['type'] == 2);
		//console.log('isNew', isNew);
		let peopleLabel = t('Find person(s) to cascade to');
		if (!isNew) {
			peopleLabel = t('Find additional person(s) to cascade to');
		}
		let realOwner = this.props.showRealOwner ? this.props.showRealOwner : false;
		let rows = metricObj.metricCascdeUserList || [];
		//console.log('rows', rows);
		let existingRows = rows.filter(u => typeof u['id'] !== 'undefined');
		//console.log('existingRows', existingRows);
		let newRows = rows.filter(u => typeof u['isNew'] !== 'undefined');
		//console.log(newRows,"newRows");
		let intervalText = metricObj.interval ? MetricFunc.default.getIntervalText(metricObj.interval) : "";
		let newMeasureMetricData = this.state.metricObj.measure_metric_data != null ? this.state.metricObj.measure_metric_data : MetricFunc.MEASURE_METRIC_DATA_TOTAL_ACHIEVED_VALUES;
		const isEnhancedCascadesEnabled = window.wbConfig?.isEnhancedCascadesEnabled ?? false;
		const shouldUseNewCascadeDropdown = isEnhancedCascadesEnabled || newMeasureMetricData != MetricFunc.MEASURE_METRIC_DATA_TOTAL;
		const displayValue = newMeasureMetricData == MetricFunc.MEASURE_METRIC_DATA_TOTAL && isEnhancedCascadesEnabled ? MetricFunc.MEASURE_METRIC_DATA_TOTAL_ACHIEVED_VALUES : newMeasureMetricData;
		let enableDropDown = false;
		if(existingRows.length > 1){
			enableDropDown = true ;
		} else if( newRows.length > 1){
			enableDropDown = true;
		} else if(existingRows.length > 0 && newRows.length > 0){
			enableDropDown = true;
		} else if(existingRows.length > 1 && newRows.length == 0){
			enableDropDown = true;
		} else if(existingRows.length == 0 && newRows.length > 1){
			enableDropDown = true;
		}
		return (
			<div className="cascade-kr-comp-wrapper">
				<div className="cascade-kr-info-wrapper">
					<div className="fieldcontent">
						<div className="labeltext-27px">{t('OVERALL KEY RESULT INFO')}</div>
					</div>
					<div className="fieldcontent">
						<div className="basickrstarttargets">
							<div className="left" style={{ marginRight: '26px'}}>
								<div className="krs-target-value-text inLineBlk targetHelp" style={{height: 24, width: "100%"}}>
									{t('Result value')}
								</div>
								<div>
									 <StyledDropdown
										options={getTargetValue(true)}
										onChange={(e) => { this.changeTargetDropdownValue(e, e.target["value"]) }}
										id={"result-value-dropdown"}
										data-testid={"result-value-dropdown"}
										value={Number(metricObj.counting)}
										aria-label={t('Result Value')}
										showStartNodeOnSelect
										optionTitleProp="name"
										optionValueProp="value"
										disabled={isOldDis}
										MenuProps={{
											style: {
											zIndex: '1500000'
											}
										}}
									/>
									<div className="clear"></div>
								</div>
							</div>
							<div className={!this.state.isStretchEnabled ? "left" : "left target-cascade"}>
								<div className={!this.state.isStretchEnabled ? "labeltext-25px" : "target-text-25px"} id="target-input">
									{t('Target value')}<TypeFaceText key="typeface" />
								</div>
								{   this.state.isStretchEnabled && (
									<div className="inLineBlk left">
										<div className="labeltext-25px marginL0">
											{t('Committed target')}
											<HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText marginL3">
											{t('When you set a Committed Result, the RAG status will follow a more aggressive curve throughout the quarter, and your progress at the end of the quarter will only be green if you achieve 100% of your target.') + t('This is helpful for financial targets, SLAs, or similar targets that you have a commitment to hit.')}
											</HelpTextComp>
										</div>
									</div>
								)
                    			}
								<div>
									<Textfield
										aria-labelledby="target-input"
										data-testid="target-value"
										className={'text-target-field' + (this.state.isStretchEnabled ? ' stretch-text-target-width' : ' text-target-width')}
										name="target"
										id="target"
										autoComplete="off"
										onChange={(e) => this.changeInputValue(e)}
										type="text"
										value={metricObj.target}
										placeholder={t('Enter Value')}
									/>
								</div>
								{isError ? this.renderError('target') : ''}
							</div>
							{ this.state.isStretchEnabled && (<div className="left target-cascade">
								<div className="labeltext-25px" id="target-input">
								</div>
								{
								<div className="inLineBlk left">
									<div className="labeltext-25px marginL0">
										{t('Stretch target')}
										<HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText marginL3">
										{t('Aim for best possible! Your stretch target is what you aspire to achieve beyond what has been committed')}
										</HelpTextComp>
									</div>
								</div>
								}
								<div>
									<Textfield
										aria-labelledby="stretch-input"
										data-testid="target-value"
										className='text-target-field stretch-text-target-width'
										name="stretch"
										id="stretch"
										autoComplete="off"
										onChange={(e) => this.changeInputValue(e)}
										type="text"
										value={metricObj.stretch}
										placeholder={t('Enter Value')}
									/>
								</div>
								{isError ? this.renderError('stretch') : ''}
							</div> )}
							<div className="clear"></div>
						</div>
					</div>
					<div className="fieldcontent">
						<div>
							<StyledDropdown
								data-testid="myAlign"
								id="unit-measure-dropdown"
								aria-label={t("Unit of measurement")}
								value={Number(metricObj.metric)}
								autoMenuWidth
								onChange={(event) => {
									this.changeMetricTypeOptions(event, event.target["value"]);
								}}
								optionTitleProp="name"
								optionValueProp="value"
								options={this.initialMetricTypeOptions}
								MenuProps={{
									style: {
									zIndex: '1500000'
									},
								}}
							/>
							<div className="clear"></div>
						</div>
					</div>
				</div>
				<div className="krBreak" aria-hidden="true" style={{ marginTop: "15px" }}></div>
				<div className="cascade-kr-spec-wrapper">
					<div className="fieldcontent">
						<div className="labeltext-27px">{t('CASCADING SPECIFICATIONS')}</div>
					</div>
					{
						(existingRows.length && !isNew) ?
							<div className="fieldcontent">
								<div>
									<CascadeResultsHeaderTableComp isNew={isNew} realOwner={realOwner}/>
								</div>
								<div className="container-scroll offsettingInput">
									{
										existingRows.map(r => <CascadeResultsTableComp key={"cascade-" + r.req_uid} tableClass="rollup-cascade-table" row={r} removeItem={this.removeItem} sendUserNotification={this.sendUserNotification} changeTextBox={this.changeTextBox}  removeUser = {true}/>)
									}
								</div>
							</div>
							: ''
					}
					<div className="fieldcontent">
						<div className="labeltext-25px">
							{peopleLabel}<TypeFaceText key="typeface" />
						</div>
						<div>
							<SearchBoxComp
								minLength="2"
								wrapperClass="cascade-results-people"
								url={"goal/getTeamAndOrgUsersList?team=true"}
								excludeAIAgents={true}
								inputProps={{
									placeholder: t("Search for people or teams"),
									className: (isError ? this.getErrorClass('select_people') : '')
								}}
								renderResultComp={this.renderPeopleSearchResults}
							//beforeFilterValues={this.filterPeopleList}
							/>
						</div>
						{isError ? this.renderError('select_people') : ''}
					</div>
					{
						rows.length ?
							<div>
								{
									newRows.length ?
										<div className="fieldcontent">
											<div style={{ width: "415px" }}>
												<CascadeResultsHeaderTableComp isNew={true} realOwner={realOwner}/>
											</div>
											<div className="container-scroll" style={{ width: "415px" }}>
												{
													newRows.map(r => <CascadeResultsTableComp
														isNew={true}
														key={"cascade-" + r.req_uid}
														tableClass="rollup-cascade-table"
														row={r}
														removeItem={this.removeItem}
														changeTextBox={this.changeTextBox} />)
												}
											</div>
										</div>
										: ''
								}
								<div className="fieldcontent">
									<div className="labeltext-25px">
										{realOwner? t("Owners to update"): t("Assignees to update")}
                                </div>
									<div>
										<div style={{display: 'flex'}}>
											<StyledDropdown
												id="select-interval-dropdown"
												aria-label= {t("How often to update?")}
												value={Number(metricObj.interval)}
												onChange={(event) => {
													this.changeInterval(event, event.target["value"]);
												}}
												required
												autoMenuWidth
												optionTitleProp="name"
												optionValueProp="value"
												disabled={isOldDis}
												                  options={MetricFunc.getIntervalOptions('default', addOkrData.isEnabledBiweeklyKR, false, Number(metricObj.interval) === krdetailConstants.INTERVAL_BIQUARTERLY)}
												MenuProps={{
													style: {
													zIndex: '1500000'
													},
												}}
											/>
											{
												(MetricFunc.isWeeklyInterval(metricObj.interval)) ?
													<div className="left">
														<div className="left ontext">{t('on')}</div>
														<div className="left">
															<StyledDropdown
																data-testid="myAlign"
																id="select-day-dropdown"
																aria-label={t('select day to update')}
																value={Number(metricObj.weekly_update_day)}
																autoMenuWidth
																onChange={(event) => {
																	this.changeWeekDayUpdate(event, event.target["value"]);
																}}
																optionTitleProp="name"
																optionValueProp="value"
																disabled={isOldDis}
																options={MetricFunc.getWeekDaysOptions()}
																MenuProps={{
																	style: {
																		zIndex: '1500000'
																	},
																}}
															/>
															<div className="clear"></div>
														</div>
														<div className="clear"></div>
													</div>
													: ''
											}
											<div className="clear"></div>
										</div>
										<div className="clear"></div>
									</div>
								</div>
								<div className="fieldcontent">
									<div>
										<TextareaFieldComp label={realOwner? `${t('Message owners will receive')}:`: `${t('Message assignees will receive')}:`} textareaProps={{ id: 'message', name: 'message', value: metricObj.message ? metricObj.message : '', onChange: this.changeMessageText }} />
									</div>
								</div>
								{
									( enableDropDown ) ?
										<div className="fieldcontent" >
											<div className="labeltext-25px" id="cal-overall" style={{maxHeight:'10px'}}>
											{t('Calculate and graph progress for my key result as')} <HelpTextComp key="measurehelp" cascadeHelpText={true}>
													<div>
														<ul>
															<li>
																<strong>{`${t('Total of achieved values')}:`}</strong> {t('If one assignee has an achieved value of "2", and another assignee has an achieved value of "3", the overall progress is "5".')}
															</li>
															<li>
																<strong>{`${t('Average of achieved values')}:`}</strong> {`${t('If one assignee has an achieved value of "2", and another assignee has an achieved value of "3", the overall progress is')} "2.5".`}
															</li>
														</ul>
													</div>
												</HelpTextComp>
											</div>
											<div>
												<StyledDropdown
													data-testid="CalculateOverDropDown"
													id="cal-overall-dropdown"
													aria-labelledby="cal-overall"
													value={Number(displayValue)}
													autoMenuWidth
													onChange={(event) => {
														this.changeProgressType(event, event.target["value"]);
													}}
													optionTitleProp="name"
													optionValueProp="value"
													options={MetricFunc.getCalculationCascadeProgressOption(shouldUseNewCascadeDropdown ? "new" : "oldCascade")}
													MenuProps={{
														style: {
															zIndex: '1500000'
														},
													}}
												/>
												<div className="clear"></div>
											</div>
										</div>
									: ''
								}
							    { this.props.customData && Object.keys(this.props.customData).length > 0 && <div className="breakline" style={{marginBottom:"-10px"}} aria-hidden="true" />}
								{  (this.props.addOkrData.groupKRCustomFields|| this.props.groupKRCustomFields ) &&
									<Customokr
										customData={this.props.customData}
										isRequiredCustomOkrFiled={this.isRequiredCustomOkrFiled}
										onCustomDataChange={(newData) => this.props.onCustomFieldsChange?.(newData)}
										customFiledRequired={true}
										renderError={this.renderError}
										isCustomSave={this.state.isCustomSave}
									/>
                                }
								<div className="breakline"></div>
								<KrMilestonesSection ref={this.krMilestonesSectionRef} source={krdetailConstants.SOURCE_CASCADE_RESULTS} {...this.props} metricState={this.state} metric={metricObj} onChange={this.handleMilestonesChange} />
								<KrRelationshipWrapper {...this.props} metric={this.props.item} saveKr={this.saveItems}/>
								<AddFinancialTargetsButton objectType="kr" objectId={this.props.item?.id} ownerUserId={this.props.realOwner?.id} />
								 <AddKrTag metric={this.props.item} goalId={this.props.goalDetails.id} taghandler={this.saveTag}
								 nplTags={this.state.nplTags}  selectednlplTags={this.state.selectednlplTags} selectednlplTagsName={this.state.selectednlplTagsName} updateTags={this.updateTags} tagsList={this.state.tagsList} searchText={this.props.krText}
								 />
								<KrAlignDependance {...this.props}
									saveDependentArr={this.saveDependentArr}
									saveAlignArr={this.saveAlignArr}
									krAlingArr={this.props.item.kr_aligns}
									krDependenciesArr={this.props.item.kr_dependent}/>
								<div className="fieldcontent">
									<StyledCheckbox
										id="exclude_objective"
										label={t("Exclude from objective progress calculation")}
										isChecked={metricObj.progress_consider}
										onChange={this.changeExcludeObjective}
									/>
								</div>
								<div className="fieldcontent">
									{
										!(this.props.goalDetails && this.props.goalDetails.all_metrics == 1) &&
										<div className="pT10">
											<div className="viewPermissionArea">
												<span>
													{t('View permissions in addition to')}{" "}
													{this.props.goalDetails.type == 1 ? ` ${t('team')} ` : ` ${t('owner')} `}
													<div className="metricTargetHelptext permissionHelpText"
														onMouseEnter={event => {
															this.setState({ permissionHelpPopUp: true });
														}}
														onMouseLeave={event => {
															this.setState({ permissionHelpPopUp: false });
														}}
													/>
													{this.state.permissionHelpPopUp && (
														<div className="basic-popup">
															{t(`You can give your whole organization permission to view your Key Result, or just your team and managers`)}
															</div>
													)}
												</span>
											</div>
											<div className="pB10">
												<PermissionComp
												{...this.props}
												teamPermissionData={this.teamPermissionData}
												bizPermissionData={this.bizPermissionData}
												permissionData={this.permissionData}
												hide={this.state.hide}
												/>
											</div>
										</div>
									}
								</div>
							</div>
							: ''
					}

			{
				this.state.confirmPopup &&
					<DeleteCommonModal
						exitDeleteModal={this.exitDeleteModal}
						deleteItems={this.saveItems}
						id=""
						title={t(this.state.isAnuualQChange ? 'Save Key Result with new duration' : 'Save Key Result with New Data Type')}
						deleteContentOne=""
						deleteContentSecondParam=""
						deletefirstTitle=""
						deleteContentSecond={t(this.state.isAnuualQChange
              ? 'Are you sure you want to change the duration on this Key Result? This will eliminate all Updates and Confidence Flags on the Key Result.'
              : 'Are you sure you want to save this key result with the new data type you selected? This will get rid of past key result data.')}
						buttonText={t(this.state.isAnuualQChange ? 'Change duration' : 'Save')}
					/>

			}
				</div>
				<div className="breakline"></div>


			</div>
		)
	}
}

export default CascadeKRComp
